export const ENGLISH = { name: "English", code: "en", label: "English" };
export const FRENCH = { name: "French", code: "fr", label: "Français (France)" };
export const CHINESE = { name: "Chinese", code: "zh", label: "中文" };
export const HINDI = { name: "Hindi", code: "hi", label: "ह िंदी" };
export const SPANISH = { name: "Spanish", code: "es", label: "Española" };
export const ARABIC = { name: "Arabic", code: "ar", label: "عربى" };
export const BENGALI = { name: "Bengali", code: "bn", label: "বাঙালি" };
export const PORTUGUESE = { name: "Portuguese", code: "pt", label: "Português" };
export const RUSSIAN = { name: "Russian", code: "ru", label: "Русский" };
export const JAPANESE = { name: "Japanese", code: "ja", label: "日本人" };
export const GERMAN = { name: "German", code: "de", label: "Deutsche" };
export const KOREAN = { name: "Korean", code: "ko", label: "한국어" };

export const ALL_LANGUAGES = [
  ENGLISH,
  FRENCH,
  CHINESE,
  HINDI,
  SPANISH,
  ARABIC,
  BENGALI,
  PORTUGUESE,
  RUSSIAN,
  JAPANESE,
  GERMAN,
  KOREAN,
];

export const allLanguageCodes = () => ALL_LANGUAGES.map(lang => lang.code);


// WEBPACK FOOTER //
// ./src/languageData/constants/languages.js